import { StandardAction } from '@infodata-group/inf-commons';
import { Employee } from './employee';

export class ActionEmployee extends StandardAction {
  public get service(): string {
    return this.employee.service.label;
  }

  public employee: Employee;

  constructor(employee: Employee) {
    super(employee.id, '', employee.id + ' - ' + employee.label);
    this.employee = employee;
  }
}
